import { jsxs as _jsxs } from "react/jsx-runtime";
const containerStyle = {
    display: 'flex',
    flexDirection: 'row',
    borderBottom: '0.55px solid rgb(240 240 240)',
    alignItems: 'center',
};
export default function PanelHeader(props) {
    const { style = {}, children } = props;
    return _jsxs("div", { style: { ...containerStyle, ...style }, children: [children, " "] });
}
